import { StatefulPopover, useStyletron, } from "@mezo-org/mezo-clay";
import { useConnectModal } from "@rainbow-me/rainbowkit";
import React, { useEffect } from "react";
import { useDisconnect } from "wagmi";
import DefaultAvatar from "../../assets/DefaultAvatar";
import useDropdownData from "../../hooks/useDropdownData";
import useWalletAccount from "../../hooks/useWalletAccount";
import ConnectedTrigger from "./ConnectedTrigger";
import Content from "./Content";
import DisconnectedTrigger from "./DisconnectedTrigger";
import { useSignInWithWallet } from "../../hooks";
/**
 * Passport Dropdown component that displays user's wallet and assets information.
 * @param {DropdownProps} props - Component props.
 * @returns {JSX.Element}
 */
export function Dropdown(props) {
    const { placement = "bottomRight", animateOutTime = 120, onSignIn, onSignOut, evmNativeAssets, matsnetAssets, overrides, triggerProps, ...restProps } = props;
    const [, theme] = useStyletron();
    const dropdownData = useDropdownData({ evmNativeAssets, matsnetAssets });
    const { openConnectModal } = useConnectModal();
    const { isConnected } = useWalletAccount();
    const { signInWithWalletAsync, isPending } = useSignInWithWallet();
    const { disconnectAsync } = useDisconnect();
    useEffect(() => {
        if (onSignIn)
            return;
        const handleSignIn = async () => {
            if (!isConnected)
                return;
            try {
                await signInWithWalletAsync();
            }
            catch (error) {
                await disconnectAsync();
            }
        };
        handleSignIn();
    }, [disconnectAsync, isConnected, onSignIn, signInWithWalletAsync]);
    if (!dropdownData || !isConnected) {
        return (React.createElement(DisconnectedTrigger
        // If connect wallet flow is not provided it fallbacks to RainbowKit's
        // connect modal
        , { 
            // If connect wallet flow is not provided it fallbacks to RainbowKit's
            // connect modal
            onClick: onSignIn || openConnectModal, isLoading: isPending, ...triggerProps?.signedOut }, "Sign in"));
    }
    return (React.createElement(StatefulPopover, { content: React.createElement(Content, { data: dropdownData, onSignOut: onSignOut }), placement: placement, animateOutTime: animateOutTime, overrides: {
            ...overrides,
            Body: {
                ...overrides?.Body,
                style: {
                    minWidth: "396px",
                    borderRadius: theme.borders.radius500,
                    boxShadow: theme.lighting.shadow500,
                    overflow: "hidden",
                    ...overrides?.Body?.style,
                },
            },
        }, ...restProps },
        React.createElement(ConnectedTrigger, { avatar: React.createElement(DefaultAvatar, null), ...triggerProps?.signedIn })));
}
//# sourceMappingURL=Dropdown.js.map